import React from 'react';
import PropTypes from 'prop-types';

// Components
import InfoPanel from './InfoPanel';
import SetStatusWidget from './SetStatusWidget';
import HubStatusWidget from './HubStatusWidget';
import StaffWidget from './StaffWidget';
import AlertUpdateWidget from './AlertUpdateWidget';
import InfoDialog from './InfoDialog';

import LineItem from './LineItem';

import { isNull } from '../constants';
import { T, FONT_MONO } from '../constants/tokens';

const HEADER = (room) => {
  const status = room.getAlertStatus();

  return (
    <>
      <div style={{ fontSize: 20, fontWeight: 600, lineHeight: '28px', letterSpacing: '-0.4px', color: T.ink }}>
        {room.getIdentifier()}
      </div>
      {/* AlertType has no `name` — this read undefined before and rendered
          "undefined Status". */}
      <div
        style={{
          fontFamily: FONT_MONO,
          fontSize: 12,
          fontWeight: 500,
          lineHeight: '16px',
          textTransform: 'uppercase',
          color: T.muted,
          marginTop: 2
        }}
      >
        {status?.getDashboardStatus() ?? 'Unknown'}
      </div>
    </>
  );
};

const CHILDREN = (room) => {
  // The badges last located here. Only those still being heard from put
  // their holder in the room now; StaffWidget lists the rest apart.
  const badges = room?.getLastSeenBadges() ?? [];
  const hereNow = badges.filter((badge) => badge.getBelongsTo() != null && badge.getIsConnected()).length;
  const hubs = room.getHubs() ?? [];

  return (
    <>
      <LineItem description='Status' value={room.getAlertStatus()?.getDashboardStatus() ?? 'Unknown'} />
      <LineItem description='Staff here now' value={String(hereNow)} mono last />

      {/* Straight under the facts: in an alert, who is in the room is the
          first thing to look for. It used to sit below the hubs, off screen. */}
      <StaffWidget badges={badges} />

      {/* A card per hub: its type, connection and battery. These replace the
          "Hubs" and "Hub connection" lines, which said the same in less. */}
      {hubs.length > 0 &&
        <HubStatusWidget hubs={hubs} isInfoPanel />
      }

      <AlertUpdateWidget updates={room.getAlertUpdates()} />
    </>
  );
};

const FOOTER = (onSetStatus) => {
  return (
    <SetStatusWidget onSetStatus={onSetStatus} />
  );
};

export default function RoomInfoPanel({ room, onSetStatus, isMobile, handleClose/*, setupMode*/ }) {
  return isMobile ? (
    <InfoDialog
      statusColor={room.getAlertStatus()?.getColor()?.main}
      header={HEADER(room)}
      footer={FOOTER(onSetStatus)}
      handleClose={handleClose}
      open={!isNull(room)}
      editHref={null /*setupMode ? '/admin/rooms/' + room.getID() : null*/}
    >
      {CHILDREN(room)}
    </InfoDialog>
  ) : (
    <InfoPanel
      statusColor={room.getAlertStatus()?.getColor()?.main}
      header={HEADER(room)}
      footer={FOOTER(onSetStatus)}
      editHref={null /*setupMode ? '/admin/rooms/' + room.getID() : null*/}
    >
      {CHILDREN(room)}
    </InfoPanel>
  );
}

RoomInfoPanel.propTypes = {
  room: PropTypes.object,
  onSetStatus: PropTypes.func,
  isMobile: PropTypes.bool,
  handleClose: PropTypes.func,
  setupMode: PropTypes.bool.isRequired
};
